import { render, staticRenderFns } from "./barStore.vue?vue&type=template&id=86fd6274&scoped=true"
import script from "./barStore.vue?vue&type=script&lang=js"
export * from "./barStore.vue?vue&type=script&lang=js"
import style0 from "./barStore.vue?vue&type=style&index=0&id=86fd6274&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fd6274",
  null
  
)

export default component.exports